import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import Result from './Result';

export default compose(withRouter)(Result);
